import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const FooterPlayer = styled.div`
  display: grid;
  position: sticky;
  grid-template-columns: repeat(3, 1fr);
  bottom: 0;
  background: var(--player-bg-main);
  backdrop-filter: blur(5px);
  padding: 12px 36px 14px;
  margin: 0 -50px;
  z-index: 101;
  border-top: 1px solid var(--grey-primary);

  @media ${breakpoints.md} {
    margin: 0 -20px;
  }

  @media ${breakpoints.sm} {
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    padding: 17px 16px 4px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--card-active);
      border-radius: 12px;
      grid-row: 1/2;
      grid-column: 1/3;
    }
  }
`;

export const FooterPlayerInfoWithActions = styled.div`
  z-index: 1;
  display: contents;

  @media ${breakpoints.sm} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9.5px 8px 9.5px 8px;
    grid-row: 1/2;
  }
`;

export const AudioImage = styled.img`
  width: 48px;
  aspect-ratio: 1/1;
  border-radius: 4px;
  object-fit: cover;

  @media ${breakpoints.sm} {
    width: 36px;
  }
`;

export const AudioName = styled.p`
  max-width: 345px;

  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const AudioDuration = styled.p`
  color: var(--white-secondary);
  white-space: nowrap;

  @media ${breakpoints.xs} {
    > span {
      display: ${({ isRelease }) => (isRelease ? "block" : "none")};
    }
  }
`;

export const AudioInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
`;

export const AudioInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomInfo = styled.div`
  display: flex;
  color: #ffffff;
  align-items: baseline;
  gap: 4px;
  line-height: normal;
`;

export const TopInfo = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const PaybackControlButton = styled.button`
  background: #fff;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${breakpoints.sm} {
    width: 32px;
    height: 32px;
  }

  div {
    transform: scale(0.8);

    @media ${breakpoints.sm} {
      transform: scale(0.5);
    }
  }
`;

export const MainActions = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: center;

  @media ${breakpoints.sm} {
    gap: 15px;

    & img {
      width: 24px;
    }

    & ${PaybackControlButton} {
      & img {
        width: 32px;
      }
    }

    & > :first-child {
      display: none;
    }

    & > :last-child {
      display: none;
    }

    // Скрывает первую IconButton
    ${({ audioType }) =>
      audioType !== "stream" &&
      `
      & > :nth-child(2) {
        display: none;
      }
    `}
  }
`;

export const LikeAndDislikeWrapper = styled.div`
  display: flex;
  gap: 8px;

  @media (min-width: 982px) {
    display: none;
  }
`;

export const SecondaryActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 14px;
  justify-content: flex-end;

  @media ${breakpoints.sm} {
    grid-row: 2/3;
    grid-column: 1/3;
    display: grid;
    grid-template-columns: 1fr auto auto;
    padding: 0;

    & button {
      grid-row: 1/2;
    }

    & button:first-child {
      grid-column: 1/2;
    }

    ${LikeAndDislikeWrapper} {
      grid-row: 1/2;
    }
  }
`;

export const ReleaseLiveName = styled.div`
  display: flex;
  gap: 4px;
`;
